const initialState = {
  search: {
    suggestions: {},
    suggestionsLoaded: false,
    detailsLoaded: false,
    distance: 10
  },
  results: {
    searchInput: [],
    resultStatus: "loading",
    resultslist: [],
  },
};

export { initialState };
